import { mergeClassName as e } from "../../utils/data.js";
import t from "./InputBox.module.js";
//#region lib/components/Input/inputBoxClassName.ts
function n({ hasError: n, active: r, disabled: i, readOnly: a, readOnlyMuted: o = !0 }, ...s) {
	return e(t.box, n && t.boxError, i && t.boxDisabled, a && o && t.boxReadOnly, r && t.boxActive, ...s);
}
//#endregion
export { n as inputBoxClassName };
